import { EditRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import "./styles/EditExamView.css";
const DisplayQuestions = (props) => {
  function handleEditClick(id, index) {
    props.setQuestionId(id);
    props.setIndex(index);
    props.setOpen("active");
  }
  return (
    <>
      <ul className="list-view">
        {props.questions.map((item, index) => {
          if (item.delete) {
            return null;
          }
          return (
            <li key={`question-${index}`} className="list-item">
              <div className="ellipsis">{item.question}</div>
              <div>
                <IconButton
                  className="icon-button"
                  color="secondary"
                  onClick={() => handleEditClick(item.id, index)}
                >
                  <EditRounded fontSize="inherit" color="secondary" />
                </IconButton>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default DisplayQuestions;
